import * as React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'

import media from '../../../services/generateMediaQueries'
import ZingIcon from '../../../assets/img/zing-icon.svg'
import CinemaBreak from '../../../assets/img/cinema/cinema-break.webp'
import Background from '../../../assets/img/cinema/cinema-header.webp'

let LOADING = false

const StyledLink = styled(Link)`
  text-decoration: none;
`

const CardWrapper = styled.div`
  cursor: pointer;
  outline: none;
  direction: ltr;

  ${props =>
    props.breakOngoing === true &&
    props.contentDirection === 'rtl' &&
    css`
      margin-left: -370px;
    `}

  ${media.lessThan('large')`
    margin-left: auto;
    margin-right: auto;
  `}
`

const CardImage = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), linear-gradient(180deg,rgba(0,0,0,0.00) 30%,#2C2F3A 100%), url('${props.cardImgUrl}')  0% 0% / cover, linear-gradient(#000000, #000000)`,
  },
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #000000;
  mix-blend-mode: normal;
  transition: all 0.5s;
`

const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 400px;
  margin: 0 0.625rem;
  background: #ffffff;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-large);
  overflow: hidden;
  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;

  ${() =>
    LOADING &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${media.lessThan('large')`
    margin: 0 0.5rem;
    margin: auto;
  `}

  &:hover {
    ${CardImage} {
      transform: scale(1.2);
    }
  }
`

const CardContent = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  padding: 2.25rem 3.125rem;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  height: 480px;
`

const Title = styled.h1`
  font-size: 1.4375rem;
  line-height: 1.9375rem;
  font-weight: var(--font-weight-boldest);
  color: #ffffff;
  margin: 0;
  text-align: center;
  width: 100%;
  text-transform: uppercase;
`

const Text = styled.p`
  margin: 0;
  color: white;
  text-align: center;
`

const BreakCard = styled(StyledCard)`
  width: 673px;
  height: 300px;
  background: unset;
  background-color: white;
  display: flex;
  flex-direction: row;

  ${media.lessThan('small')`
    width: 330px;
    flex-direction: column;
    height: 450px;
    padding-top: 1rem;
    background: url(${Background}) center top;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #fff;
    margin-left: auto;
    margin-right: auto;
  `}
`

const BreakImage = styled.div`
  width: 343px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 12.5rem;
  }
  ${media.lessThan('small')`
    width: 300px;
    height: 250px;
    padding-top: 1rem;
  `}
`

const BreakText = styled.div`
  width: calc(100% - 343px);

  h1 {
    line-height: 2rem;
  }

  p {
    color: var(--color-fg-light);
    width: 80%;
  }

  ${media.lessThan('small')`
    width: 100%;
    text-align: center;
    height: 200px;
    padding: 0 0.5rem 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    h1 {
      font-size: 1.25rem !important;
      margin-bottom: 0px;
    }

    p {
      font-size: 1rem !important;
    }
  `}
`

function MoviesCard(props) {
  const {
    cardImgUrl,
    title,
    link = '',
    onClick,
    id,
    className,
    loading,
    error,
    onRetry,
    breakOngoing,
    contentDirection,
    statusDescription,
  } = props

  LOADING = loading

  const CinemaCardTitle = () => (
    <>
      {/* <h1>
                Our Cinemas are
                <br />
                Taking a Break{' '}
              </h1> */}
      <h1>
        OUR CINEMAS ARE
        <br />
        BACK ON THE
        <br />
        BIG SCREEN
      </h1>
    </>
  )

  const CardComponent = () => (
    <CardWrapper
      breakOngoing={breakOngoing}
      contentDirection={contentDirection}
    >
      <StyledLink
        to={link}
        onClick={
          loading
            ? e => {
                e.preventDefault()
                if (error) {
                  onRetry()
                }
              }
            : onClick
        }
      >
        {!breakOngoing ? (
          <StyledCard className={className}>
            {!LOADING ? (
              <>
                <CardImage cardImgUrl={cardImgUrl} />
                <CardContent>
                  <Title>{title}</Title>
                </CardContent>
              </>
            ) : (
              <>
                <img src={ZingIcon} alt="Zing icon" />
                {error && (
                  <>
                    <Text>Failed to load Now Showing.</Text>
                    <Text>Tap to retry.</Text>
                  </>
                )}
              </>
            )}
          </StyledCard>
        ) : (
          <BreakCard>
            <BreakImage>
              <img src={CinemaBreak} alt="Cinema Break" />
            </BreakImage>
            <BreakText>
              <CinemaCardTitle />
              <p>{statusDescription}</p>
            </BreakText>
          </BreakCard>
        )}
      </StyledLink>
    </CardWrapper>
  )

  if (LOADING) {
    return <CardComponent />
  }

  return (
    <Fade right distance="1rem" delay={300 + 50 * id} duration={300} force>
      <CardComponent />
    </Fade>
  )
}

MoviesCard.propTypes = {
  // TODO: specify prop types
}

export default MoviesCard
